// extracted by mini-css-extract-plugin
export default {"courses":"styles_courses__4mFky","__in":"styles___in__w5YDj","title":"styles_title__l9k4U","sub_title":"styles_sub_title__N8oa-","list":"styles_list__tbfcr"};